import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

const sendToAnalytics = (metric: any) => {
  const { name, delta, value, id } = metric;
  
  // Send to Google Analytics
  if (window.gtag) {
    window.gtag('event', name, {
      event_category: 'Web Vitals',
      event_label: id,
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      non_interaction: true,
    });
  }
  
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log('Web Vitals:', { name, delta, value, id });
  }
};

export const reportWebVitals = () => {
  getCLS(sendToAnalytics);
  getFID(sendToAnalytics);
  getFCP(sendToAnalytics);
  getLCP(sendToAnalytics);
  getTTFB(sendToAnalytics);
};

// Performance monitoring
export const measurePageLoad = () => {
  if (typeof window !== 'undefined' && window.performance) {
    const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    
    if (navigation) {
      const metrics = {
        dns: navigation.domainLookupEnd - navigation.domainLookupStart,
        tcp: navigation.connectEnd - navigation.connectStart,
        ttfb: navigation.responseStart - navigation.requestStart,
        domContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
        loadComplete: navigation.loadEventEnd - navigation.loadEventStart,
        total: navigation.loadEventEnd - navigation.fetchStart
      };
      
      if (window.gtag) {
        window.gtag('event', 'page_load_metrics', {
          event_category: 'Performance',
          custom_map: {
            dns_time: 'dns',
            tcp_time: 'tcp',
            ttfb_time: 'ttfb',
            dom_content_loaded: 'domContentLoaded',
            load_complete: 'loadComplete',
            total_load_time: 'total'
          },
          dns_time: Math.round(metrics.dns),
          tcp_time: Math.round(metrics.tcp),
          ttfb_time: Math.round(metrics.ttfb),
          dom_content_loaded: Math.round(metrics.domContentLoaded),
          load_complete: Math.round(metrics.loadComplete),
          total_load_time: Math.round(metrics.total)
        });
      }
    }
  }
};
